package com.flowyride.core.designsystem.component

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.size
import androidx.compose.material3.IconButton
import androidx.compose.material3.LocalContentColor
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.unit.dp

/**
 * Chevron button: points down when collapsed, up when expanded.
 * Drawn rather than a glyph, so it renders the same with every platform font.
 */
@Composable
fun ExpandToggle(
    expanded: Boolean,
    onToggle: () -> Unit,
    contentDescription: String,
    modifier: Modifier = Modifier,
) {
    val rotation by animateFloatAsState(if (expanded) 180f else 0f)
    val color = LocalContentColor.current
    IconButton(onClick = onToggle, modifier = modifier.semantics { this.contentDescription = contentDescription }) {
        Canvas(Modifier.size(18.dp).rotate(rotation)) {
            val stroke = 2.5.dp.toPx()
            val left = Offset(size.width * 0.15f, size.height * 0.35f)
            val tip = Offset(size.width * 0.5f, size.height * 0.7f)
            val right = Offset(size.width * 0.85f, size.height * 0.35f)
            drawLine(color, left, tip, stroke, StrokeCap.Round)
            drawLine(color, tip, right, stroke, StrokeCap.Round)
        }
    }
}
